import { module as Module } from 'modujs';
import { $screenDebounce } from '../stores/screen';

export default class extends Module {
    constructor(m) {
        super(m);

        // Binding
        this.onResize = this.onResize.bind(this);

        // UI
        this.$area = this.$('area')[0];
        this.$wrapper = this.$('wrapper')[0];

        // Data
        this.diffWidth = 0;
        this.diffHeight = 0;
        this.ratioWidth = 0;
        this.progress = 0;
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        this.setMetrics();
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.unbindScreenListener = $screenDebounce.subscribe(this.onResize);
    }

    unbindEvents() {
        this.unbindScreenListener?.();
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onResize({ width, height }) {
        this.setMetrics();
    }

    // =============================================================================
    // Methods
    // =============================================================================
    setMetrics() {
        const areaWidth = this.$area.offsetWidth;
        const areaHeight = this.$area.offsetHeight;
        const wrapperWidth = this.$wrapper.offsetWidth;
        const wrapperHeight = this.$wrapper.offsetHeight;

        this.diffWidth = wrapperWidth - areaWidth;
        this.diffHeight = wrapperHeight - areaHeight;
        this.ratioWidth = areaWidth / wrapperWidth;

        this.setStyles();
    }

    setStyles() {
        requestAnimationFrame(() => {
            this.el.style.setProperty('--ratio', this.ratioWidth);
            this.el.style.setProperty('--diff-width', `${this.diffWidth}px`);
            this.el.style.setProperty('--diff-height', `${this.diffHeight}px`);
        });
    }
}
